import { FC, useState } from 'react';

import { useAvailableLookupTypes } from '../hooks/useAvailableLookupTypes';
import { useSubmitLookupForm } from '../hooks/useSubmitLookupForm';
import { FormContext } from './FormContext';

/**
 * A context provider that holds the Contact Lookup page's form state,
 * validates user input, and handles submission by way of redirect.
 */
export const FormContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const availableLookupTypes = useAvailableLookupTypes();
  const [identifier, setIdentifier] = useState('');
  const [lookupType, setLookupType] = useState(availableLookupTypes[0]);
  const { submit, isSubmitting, canSubmit } = useSubmitLookupForm({ identifier, lookupType });

  return (
    <FormContext.Provider
      value={{
        availableLookupTypes,
        identifier,
        isSubmitting,
        canSubmit,
        lookupType,
        setIdentifier,
        setLookupType,
        submit,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};
